(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-bennos-choice"] && !Shopify.designMode) return;
  try {
    // Cloud Search adds its filters asynchronously immediately before the product grid.
  // Keep the recommendation between those controls and the products after each render.
  if (!customElements.get('cw-bennos-choice')) {
    customElements.define('cw-bennos-choice', class extends HTMLElement {
      connectedCallback() {
        if (this.filtersPlaced) return;
        const parent = this.parentElement;
        if (!parent) return;
        const placeAfterFilters = () => {
          const filters = parent.querySelector(':scope > #cloud_search_filters_root');
          if (!filters) return;
          this.filtersPlaced = true;
          this.filterObserver?.disconnect();
          if (filters.nextElementSibling !== this) filters.after(this);
        };
        this.filterObserver = new MutationObserver(placeAfterFilters);
        this.filterObserver.observe(parent, { childList: true });
        placeAfterFilters();
      }
      disconnectedCallback() {
        this.filterObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cw-eivy-promo"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cw-eivy-promo')){
customElements.define('cw-eivy-promo',class extends HTMLElement{
connectedCallback(){const remaining=Date.parse('2026-10-25T16:00:00Z')-Date.now();if(remaining<=0){this.remove();return;}this.expiry=setTimeout(()=>this.remove(),Math.min(remaining,2147483647));}
disconnectedCallback(){clearTimeout(this.expiry);}
});
}
  } catch(e) { console.error(e); }
})();

})();
